import { AssessmentSubmodulesNames } from 'components/ReportsModule/types';
import { useState } from 'react';
type UseModuleTabSelector = [
  { selectedModule: AssessmentSubmodulesNames; showAll: boolean },
  {
    setSelectedModule: (module: AssessmentSubmodulesNames) => void;
  }
];
const useModuleTabSelector = (): UseModuleTabSelector => {
  const [selectedModule, setSelectedModule] = useState<any>(AssessmentSubmodulesNames.ALL_MODULES);
  const showAll = selectedModule === AssessmentSubmodulesNames.ALL_MODULES;

  return [{ selectedModule, showAll }, { setSelectedModule }];
};

export default useModuleTabSelector;
